import { BasicComponent, ComponentChild, ComponentChildren } from "haxt";

import "./Card.scss";
export namespace Card {
	export type Props = {
		class?: JSX.HTMLAttributes["class"];
		style?: JSX.HTMLAttributes["style"];
		[BasicComponent.Children]?: ComponentChildren;
	};
}
export abstract class Card<T = {}> extends BasicComponent<T & Card.Props> {
	protected override receivedProps(props: any, children: ComponentChild[]): void {
		super.receivedProps(props, children);
		// schedule an update to render with new props
		// TODO: better handling?
		this.update();
	}

	get cls() {
		return BasicComponent.mergeClasses(
			{ Card: true },
			this.props.class
		);
	}
}
